module.exports = __webpack_public_path__ + "static/terminal-platniczy-ff52ff2acc76c7ab7ac842566a6caefc.jpg";